const defaultOpeningClosingTime = [
  {
    id: 1,
    dayOfWeek: "Sunday",
    allowed24Hour: true,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 2,
    dayOfWeek: "Monday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 3,
    dayOfWeek: "Tuesday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 4,
    dayOfWeek: "Wednesday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 5,
    dayOfWeek: "Thursday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 6,
    dayOfWeek: "Friday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
  {
    id: 7,
    dayOfWeek: "Saturday",
    allowed24Hour: false,
    openingTime: "06:00 AM",
    closingTime: "10:00 PM",
    closed: false,
  },
];

const allWeekDays = [
  { name: "Sunday", value: "Sunday" },
  { name: "Monday", value: "Monday" },
  { name: "Tuesday", value: "Tuesday" },
  { name: "Wednesday", value: "Wednesday" },
  { name: "Thursday", value: "Thursday" },
  { name: "Friday", value: "Friday" },
  { name: "Saturday", value: "Saturday" },
];
const countries = [
  { name: "India", dialCode: "+91", countryCode: "IN" },
  { name: "Saudi Arabia", dialCode: "+966", countryCode: "SA" },
];


const defaultStartTime = {
  hours: 12,
  minutes: 0,
  period: "AM",
};

const defaultEndTime = {
  hours: 12,
  minutes: 30,
  period: "AM",
};

const allMonths = [
  { name: "1 Month", value: 1 },
  { name: "2 Month", value: 2 },
  { name: "3 Month", value: 3 },
  { name: "4 Month", value: 4 },
  { name: "5 Month", value: 5 },
  { name: "6 Month", value: 6 },
  { name: "7 Month", value: 7 },
  { name: "8 Month", value: 8 },
  { name: "9 Month", value: 9 },
  { name: "10 Month", value: 10 },
  { name: "11 Month", value: 11 },
  { name: "12 Month", value: 12 },

];

const allYears = [
  { name: "1 Year", value: 1 },
  { name: "2 Year", value: 2 },
  { name: "3 Year", value: 3 },
  { name: "4 Year", value: 4 },
  { name: "5 Year", value: 5 },
  { name: "6 Year", value: 6 },
  { name: "7 Year", value: 7 },
  { name: "8 Year", value: 8 },
  { name: "9 Year", value: 9 },
  { name: "10 Year", value: 10 },
  { name: "11 Year", value: 11 },
  { name: "12 Year", value: 12 },

];
const brandInfoDemoData = {
  brandInfo: {
    logo: {
      type: String,
      default: null,
    },
    loginPageBGImage: {
      type: String,
      default: null,
    },
    theme: {
      primaryColor: { type: String, default: "#000000" }, // add default color here
      secondaryColor: { type: String, default: "#FFFFFF" }, // add default color here
      // add other settings here
    },
  },
};

export {
  defaultOpeningClosingTime,
  countries,
  allWeekDays,
  defaultStartTime,
  defaultEndTime,
  allMonths,
  allYears,
  brandInfoDemoData
};
